import { ExternalLink } from "lucide-react";
import GlowButton from "./GlowButton";
import content from "../content";

export default function SiteFooter() {
  const { mainSite, brand, footer } = content;

  return (
    <footer className="relative w-full bg-ink border-t border-white/10 py-14 md:py-16 overflow-hidden" data-testid="site-footer">
      <div
        className="pointer-events-none absolute bottom-0 left-1/2 -translate-x-1/2 w-[90vw] h-[26vw] max-w-[900px] opacity-25"
        style={{ background: "radial-gradient(ellipse at bottom, rgba(33,112,232,0.4), transparent 70%)" }}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-3xl mx-auto px-6 flex flex-col items-center gap-7 text-center">
        <img src={brand.logo} alt={`Logo ${brand.name}`} className="h-14 w-auto opacity-90" />
        <GlowButton
          href={mainSite.href}
          variant="ghost"
          testId="main-site-link"
          icon={<ExternalLink size={18} />}
        >
          {mainSite.label}
        </GlowButton>
        <p className="font-poppins text-white/40 text-xs md:text-sm tracking-wide">
          {footer.copyright}
        </p>
      </div>
    </footer>
  );
}
